import { createFileRoute } from "@tanstack/react-router";

import { UserDetailPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/users/$user_id")({
  component: UserDetailRoute,
});

function UserDetailRoute() {
  const { user_id } = Route.useParams();
  return <UserDetailPage userId={user_id} />;
}
